import { render, staticRenderFns } from "./NumbersListPage.vue?vue&type=template&id=ab12f7e0"
import script from "./NumbersListPage.vue?vue&type=script&lang=js"
export * from "./NumbersListPage.vue?vue&type=script&lang=js"
import style0 from "./NumbersListPage.vue?vue&type=style&index=0&id=ab12f7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports